import styled from "styled-components"

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 0 0;
    gap: 4px;
    grid-column: ${(props) => `span ${props.columnSpan}`};
`

export const Title = styled.h5`
    color: #495057;
    font-feature-settings:
        "clig" off,
        "liga" off;
    font-size: 12px;
    font-weight: 400;
    line-height: normal;

    margin-bottom: 0;
`

export const Subtitle = styled.p`
    color: #212529;
    font-feature-settings:
        "clig" off,
        "liga" off;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;

    margin-bottom: 0;

    text-overflow: ellipses;
`
